export default __webpack_public_path__ + "static/media/trees-mist.79ea98c3.gif";